export const PLATFORM_PANEL_ROLES = ['super_admin', 'platform_admin'];

export function isPlatformPanelUser(role) {
    return PLATFORM_PANEL_ROLES.includes(role);
}

export function canManagePlatformTeam(role) {
    return role === 'super_admin';
}
